import type { ComponentType } from "react";
import { useParams } from "react-router";
import { ExternalRedirect } from "@/components/layout/external-redirect";
import { useWebsiteUrl } from "@/lib/site";

/**
 * A page the website takes over once it is a separate site: anyone who opens it is sent to the website's copy (at `address`, which may
 * use the page's own parameters), and until then the app's own page shows.
 */
export function websiteOwns(
  load: () => Promise<{ default: ComponentType }>,
  address: (params: Record<string, string | undefined>) => string,
) {
  return async () => {
    const Page = (await load()).default;
    return {
      Component: function WebsiteOwnedPage() {
        const site = useWebsiteUrl();
        const params = useParams();
        return site ? <ExternalRedirect to={`${site}${address(params)}`} /> : <Page />;
      },
    };
  };
}
